import * as React from "react";
import { Link, LinkProps } from "react-router-dom";
import Button, { ButtonProps } from "./Button";


export type LinkButtonProps = ButtonProps & LinkProps;

class LinkButton extends React.Component<LinkButtonProps>{

    private link = (p: any) => <Link {...p} {...this.props} />;

    render() {
        return <Button {...this.props} component={this.link}>
            {this.props.children}
        </Button>
    }
}

export default LinkButton;
